// components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function ProtectedRoute({ isAuthenticated, roles = [], children }) {
  const user = useSelector((state) => state.login.user);
  const userRole = user?.role;

  // 1. Check authentication
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 2. If roles are provided, check if user's role is allowed
  if (roles.length > 0 && !roles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
